import { App } from 'vue';
import InputText from './InputText.vue';
import InputNumber from './InputNumber.vue';
import InputTextArea from './InputTextArea.vue';
import InputSelect from './InputSelect.vue';
import InputRadio from './InputRadio.vue';
import InputRadioGroup from './InputRadioGroup.vue';
import InputCheckbox from './InputCheckbox.vue';
import Form from './Form.vue';
import CallToAction from '@/project/form/CallToAction.vue';

export default function config(app: App): void {
    app.component('CallToAction', CallToAction);
    app.component('InputText', InputText);
    app.component('InputNumber', InputNumber);
    app.component('InputTextArea', InputTextArea);
    app.component('InputSelect', InputSelect);
    app.component('InputRadio', InputRadio);
    app.component('InputRadioGroup', InputRadioGroup);
    app.component('InputCheckbox', InputCheckbox);
    // eslint-disable-next-line vue/no-reserved-component-names,vue/multi-word-component-names
    app.component('Form', Form);
}
